import {createReducer, on} from '@ngrx/store';
import {StateStatus} from "../../models/state-status.models";
import {executeGlobalSearch, executeGlobalSearchFailure, executeGlobalSearchSuccess} from "./global-search.action";
import {TenantRole} from "../../models/tenant-role.model";
import {GlobalSearchResultItem} from "../../models/global-search.model";

export interface GlobalSearchState {
  globalSearchResult: GlobalSearchResultItem[] | null
  error: string | null;
  status: StateStatus;
}

export const initialState: GlobalSearchState = {
  globalSearchResult: null,
  error: null,
  status: 'pending' as StateStatus,
};

export const globalSearchReducer = createReducer(
  initialState,
  on(executeGlobalSearch, (state, { searchTerm }): GlobalSearchState => ({
    ...state,
    status: 'loading' as StateStatus,
  })),
  on(executeGlobalSearchSuccess, (state, { globalSearchResults }): GlobalSearchState => ({
    ...state,
    globalSearchResult: globalSearchResults,
    status: 'loadSuccess' as StateStatus,
  })),
  on(executeGlobalSearchFailure, (state ): GlobalSearchState => ({
    ...state,
    status: 'loadError' as StateStatus,
  })),
);



